import { Injectable } from '@angular/core';
import { QualtricsSurveyCookie } from '@core/enums/qualtrics-survey-cookie.enum';
import { Script } from '@core/models/entity/script.interface';
import { User } from '@core/states/user/user-state.model';
import { CookieService } from 'ngx-cookie-service';

import { AppSettingsService } from '../app-settings/app-settings.service';
import { ScriptService } from '../script/script.service';
import { UserService } from '../user/user.service';
import { WindowRef } from '../window-ref/window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class QualtricsService {
  private readonly QUALTRICS_SCRIPT = 'assets/scripts/qualtrics.js';
  qualtricsScript: Script;
  qualtricsLoadEvent: CustomEvent<any>;
  isEventDispatched = false;
  user: User;
  salesforceId: string;
  userId: string;
  b2cId: string;
  environmentName: string;

  constructor(
    private appSettingsService: AppSettingsService,
    private scriptService: ScriptService,

    private windowRef: WindowRef,
    private userService: UserService,
    private cookieService: CookieService
  ) {
    this.environmentName =
      this.appSettingsService.configuration.environmentSettings.Name;

    this.userService.getUser().subscribe((user: User) => {
      if (user) {
        this.user = user;
        this.setUserEmbededData();
      }
    });

    this.qualtricsLoadEvent = new CustomEvent('load_qsi_js', {
      detail: {
        Q_ZID: this.appSettingsService.configuration.qualtricsSettings.Q_ZID
      }
    });
  }

  public async load(): Promise<void> {
    this.qualtricsScript = {
      name: 'qualtrics',
      src: this.QUALTRICS_SCRIPT
    };

    await this.scriptService.loadScript(this.qualtricsScript);

    if (!this.isEventDispatched) {
      this.windowRef.nativeWindow.dispatchEvent(this.qualtricsLoadEvent);
      await this.onQualtricsScriptLoaded();
      this.isEventDispatched = true;
    }

    this.windowRef.nativeWindow.QSI.API.unload();
    this.windowRef.nativeWindow.QSI.API.load();
    this.windowRef.nativeWindow.QSI.API.run();
  }

  private onQualtricsScriptLoaded(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.windowRef.nativeWindow.addEventListener(
        'qsi_js_loaded',
        () => {
          resolve();
        },
        false
      );
    });
  }

  private setUserEmbededData(): void {
    this.windowRef.nativeWindow.identity = this.user.userId
      ? this.user.userId
      : 'N/A';
    this.windowRef.nativeWindow.b2cId = this.user.b2cId
      ? this.user.b2cId
      : 'N/A';
    this.windowRef.nativeWindow.environment = this.environmentName
      ? this.environmentName
      : 'N/A';
  }

  //reset all CCT survey cookies
  public resetAllCctSurveyCookies(): void {
    for (const svCookie in QualtricsSurveyCookie) {
      this.cookieService.set(svCookie, '0');
    }
  }
}
